<template>
  <div class="scangiftmodule" :style="styleForBg">
    <div class="scangiftmodule-legend">
      <span v-if="titlePrefix">{{ titlePrefix }}</span>
      <TextFormatter :text="title"></TextFormatter>&nbsp; <!-- 加个空格是因为渲染骨架屏时，有空格能够撑起legend高度 -->
    </div>
    <div class="scangiftmodule-main">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from 'vue-demi';
import { RawSkin } from '../api';
import TextFormatter from '@tencent/wphk-components-text-formatter/index.vue';
import DefaultTopBg from '../assets/default_up_bg.png';
import DefaultDownBg from '../assets/default_down_bg.png';

export default defineComponent({
  name: 'Container',
  components: {
    TextFormatter,
  },
  props: {
    skin: Object as PropType<RawSkin>,
    title: String,
    /** 顶部标题前缀 */
    titlePrefix: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    const styleForBg = computed(() => {
      if (props.skin) {
        const bgImg1 = `url(${props.skin.bgTopImg || DefaultTopBg}) no-repeat center top/100% auto`; // 允许不配置top img
        const bgImg2 = `url(${props.skin.bgBottomImg || DefaultDownBg}) no-repeat center bottom/100% auto`;  // 允许不配置bottom img

        return {
          background: `${bgImg1}, ${bgImg2}`,
          backgroundColor: props.skin.bgColor || '#FFFFFF',
        };
      }
      return {};
    });

    return {
      styleForBg,
    };
  },
});
</script>

<style scoped lang="less">
@import (reference) "../less/main.less";

.scangiftmodule {
  border-radius: 16/@rem;
  // background: url('../assets/default_up_bg.png') no-repeat center top/100% auto,
  //   url('../assets/default_down_bg.png') no-repeat center bottom/100% auto;
  background-color: #FFFFFF;
  padding: 24/@rem 32/@rem;
  font-family: PingFang HK;

  &-legend {
    color: #000;
    text-shadow: 0/@rem 0/@rem 10/@rem rgba(7, 193, 96, 0.05);

    font-size: 34/@rem;
    font-style: normal;
    font-weight: 500;
    line-height: 48/@rem;
  }
  &-main {
    margin-top: 14/@rem;
  }
}
</style>

<style lang="less" scoped>
@import "../less/spring-skin.less";
</style>
